import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopy from './index.vue';

var InboundOrderBookingAddBookingPage = function (_super) {
  __extends(InboundOrderBookingAddBookingPage, _super);

  function InboundOrderBookingAddBookingPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InboundOrderBookingAddBookingPage = __decorate([Component({
    components: {
      AddEditCopy: AddEditCopy
    }
  })], InboundOrderBookingAddBookingPage);
  return InboundOrderBookingAddBookingPage;
}(Vue);

export default InboundOrderBookingAddBookingPage;